import { Component, OnInit, Input } from '@angular/core';
import moment from 'moment';
import {
  FiltersModel,
  CustomerModel,
  KanziStatus,
} from '@kanzi-apes/kanzi-models';

@Component({
    selector: 'lib-kanzi-mantainance-revisions-count',
    templateUrl: './kanzi-mantainance-revisions-count.component.html',
    styleUrls: ['./kanzi-mantainance-revisions-count.component.scss'],
    standalone: false
})
export class KanziMantainanceRevisionsCountComponent implements OnInit {
  @Input() customer!: CustomerModel;
  today: number = 0;
  description1: string = '';
  description2: string = '';
  description3: string = '';
  type1: string = '';
  type2: string = '';
  type3: string = '';
  path: string = '';
  filter1!: FiltersModel;
  filter2!: FiltersModel;
  filter3!: FiltersModel;
  monthName: string = '';

  constructor() {}

  ngOnInit(): void {}
  ngOnChanges() {
    this.monthName = moment(new Date()).startOf('month').format('MMMM');
    this.description1 = 'Hoy';
    this.description2 = `Total ${this.monthName}`;
    this.description3 = 'Total';
    this.type1 = 'primary';
    this.type2 = 'warning';
    this.type3 = 'success';
    if (this.customer) {
      this.path = 'maintenance/revisions/';
      this.today = Date.now();
      const today = moment().format('YYYY-MM-DD');
      const minDate = moment(new Date()).startOf('month').format('YYYY-MM-DD');
      const maxDate = moment(new Date()).endOf('month').format('YYYY-MM-DD');
      this.filter1 = {
        customer_id: this.customer.id,
        page: 1,
        page_size: 1,
        created: today,
        status: KanziStatus.COMPLETED,
      };
      this.filter2 = {
        customer_id: this.customer.id,
        page: 1,
        page_size: 1,
        created_min: minDate,
        created_max: maxDate,
        status: KanziStatus.COMPLETED,
      };
      this.filter3 = {
        customer_id: this.customer.id,
        page: 1,
        page_size: 1,
        status: KanziStatus.COMPLETED,
      };
    } else {
      this.path = 'maintenance/revisions/';
      this.today = Date.now();
      const today = moment().format('YYYY-MM-DD');
      const minDate = moment(new Date()).startOf('month').format('YYYY-MM-DD');
      const maxDate = moment(new Date()).endOf('month').format('YYYY-MM-DD');
      this.filter1 = {
        page: 1,
        page_size: 1,
        status: KanziStatus.COMPLETED,
        created: today,
      };
      this.filter2 = {
        page: 1,
        page_size: 1,
        status: KanziStatus.COMPLETED,
        created_min: minDate,
        created_max: maxDate,
      };
      this.filter3 = {
        page: 1,
        page_size: 1,
        status: KanziStatus.COMPLETED,
      };
    }
  }
}
